<template>
  <div :class="`side-set-compo ${isShrink ? 'shrink' : ''}`">
    <div class="set-view flx-col-ctr">
      <div class="icon flx-ctr">
        <van-image
          width="21px"
          :src="require('@/imgs/icon/set2.png')"
          :show-error="false"
          :show-loading="false"
          @click="isShrink = !isShrink"
        />
      </div>
      <div class="icon flx-ctr">
        <van-image
          width="14px"
          :src="isPlayAudio ? require('@/imgs/icon/m_open.png') : require('@/imgs/icon/m_close.png')"
          :show-error="false"
          :show-loading="false"
          @click="onChangePlayAudio"
        />
      </div>
      <div class="icon flx-ctr">
        <van-image
          width="21px"
          style="margin: 3px 2px 0 0"
          :src="require('@/imgs/icon/nav.png')"
          :show-error="false"
          :show-loading="false"
          @click="toMap"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isPlayAudio: false,
      isShrink: false,
      isFirst: true,
    };
  },
  created() {
    document.body.addEventListener('click', () => {
      if (this.isFirst) {
        const audio = document.getElementById('music');
        audio.play();// 播放
        this.isFirst = false;
        this.isPlayAudio = true;
      }
    });
  },
  methods: {
    onChangePlayAudio() {
      const audio = document.getElementById('music');
      this.isPlayAudio = !this.isPlayAudio;
      if (this.isPlayAudio) {
        audio.play();
        console.log('暂停');
      } else {
        audio.pause();
        console.log('播放');
      }
    },
    // 去地图
    toMap() {
      // eslint-disable-next-line max-len
      const url = 'https://map.qq.com/m/place/info/uid=1450284733098685929&word=%E4%BF%A1%E4%B9%89%E9%87%91%E5%BE%A1%E5%8D%8A%E5%B1%B1%E8%90%A5%E9%94%80%E4%B8%AD%E5%BF%83&type=point';
      window.location.href = url;
    },
  },
};
</script>
<style lang="less" scoped>
@shrinkHeight: 28px;
@iconWidth: 34px;
.side-set-compo {
  position: absolute;
  right: .3rem;
  top: 8vh;
  z-index: 3001;
  padding: 10px 0;
  min-height: @shrinkHeight;
  overflow: hidden;
  font-size: 15px;
  color: white;
  overflow: hidden;
  transition: height .5s linear;
  &.shrink {
    height: @shrinkHeight;
  }
  .set-view {
    .icon {
      width: @iconWidth;
      height: @iconWidth;
      margin: 5px;
      background-color: rgba(0, 0, 0, 0.4);
      border-radius: @iconWidth / 2;
    }
  }
}
</style>
